import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const contrastCheckerTool: Tool = {
  id: "contrast-checker",
  name: () => m.cc_tool_name(),
  description: () => m.cc_tool_description(),
  icon: "🌗",
  basePath: "/contrast-checker",
  status: "stable",
  tags: ["design", "color", "accessibility", "wcag", "contrast-checker"],
};
